import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({

  DropableLabel: {
    // backgroundColor: inAnswer ? "#1db2d7" : "#fff",
    // border: `2px ${borderColor} ${borderStyle}`,
    borderRadius: 10,
    // marginTop: marginTop,
    // marginRight: right,
    // transform: rotate,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 40,
    width: 40,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      width: 25,
    }
  },
  labelText: {
    margin: 10,
    color: "#003e4c",
    width: 20,
    height: 25,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      margin: 2,
      height: 15,
      width: 20,
    }
  },
  dragableDiv: {
    justifyContent: 'center', alignItems: 'center', height: 35, width: 40, position: "relative", zIndex: 12, cursor: "pointer",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 26, width: 35,
    },
  },
  shadowDiv: {
    justifyContent: 'center', alignItems: 'center', height: 35, width: 40,  marginLeft: 3, marginTop: 7, cursor: "pointer", border: "1.5px solid #003e4c", borderRadius: 5, backgroundColor: "#003e4c", zIndex: 0, position: 'absolute',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 26, width: 35,
    },
  },
  textContainer: {
    justifyContent: 'center', alignItems: 'center', height: 35, width: 35, position: "relative", zIndex: 1, cursor: "pointer", border: "1.5px solid #003e4c", borderRadius: 5, backgroundColor: "transparent",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 22, width: 23,
    },
  },

  text:{
    color: "#003e4c", fontSize: 24, fontFamily: "Rubik", letterSpacing: 1, marginTop: -3,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 15
    },
  }
});

export default styles;
